import Index from './components/Index.vue';
import Donate from './components/Donate.vue';
import Contact from './components/Contact.vue';
import MyMap from './components/MyMap.vue';
import Road from './components/Road.vue';
import {siteName} from './constants.js';
import TownRoadsMap from './components/TownRoadsMap.vue';
import StateMap from './components/StateMap.vue';

// Routes:
// /index == Manual links to sections with random road featured?
// /map == Mapbox map page
// /towns == GET all towns in DB
// /towns/{town name} == Get all roads for town name
// /towns/{town name}/roads/{road class} == Get all roads for town name by road class (dirt, gravel, class 4, etc.)
// /towns/{town name}/roads/{road class}/{road name} == Specific road

const routes = [
  { // Index
    path: "/",
    name: "index",
    component: Index,
    props: {
      siteName: siteName
    }
  },
  { // Donate
    path: "/donate",
    name: "donate",
    component: Donate,
    props: {
      siteName: siteName
    }
  },
  { // Contact
    path: "/contact",
    name: "contact",
    component: Contact,
    props: {
      siteName: siteName
    }
  },
  { // /mymap == Mapbox My Map page
    path: '/mymap', 
    name: 'myMap',
    component: MyMap,
    props: {
      siteName: siteName
    }
  },
  { // /towns == GET all towns in DB
    path: '/towns', 
    name: 'towns',
    component: StateMap,
    props: {
      siteName: siteName
    }
  },
  { // /towns/{town name} == Get all roads for town name
    path: '/towns/:town',
    name: 'roadsByTown',
    component: TownRoadsMap,
    props: {
      siteName: siteName
    }
  },
  { // /towns/{town name}/roads/{road class}/{road name} == Specific road
    path: '/towns/:town/roads/:roadname',
    name: 'road', 
    component: Road,
    props: {
      default: true,
      siteName: siteName
    }
  }
];

export default routes;